import { useEffect } from "react";
const useAutoFocus = (ref, autoFocus) => {
    useEffect(() => {
        if (!autoFocus || !ref.current) {
            return;
        }
        ref.current.focus({ preventScroll: true });
    }, [autoFocus]);
};
export default useAutoFocus;
//# sourceMappingURL=useAutoFocus.js.map